import { render, staticRenderFns } from "./DataLoading.vue?vue&type=template&id=5600541c&scoped=true"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"
import style0 from "./DataLoading.vue?vue&type=style&index=0&id=5600541c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600541c",
  null
  
)

export default component.exports